import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const CitizenHistoryInfoService = {
    getCitizenHistory: async (id, filters = {}) => axios
        .post(API_URL + "/reports/citizen-history-info/" + id + "/data", filters)
        .then(({data}) => data)
        .catch((err) => {
            throw err;
        }),
};

export default CitizenHistoryInfoService;
